<template>
  <div class="statis-page">
    <!-- 搜索内容 -->
    <div class="filter-container">
      <el-form :inline="true" :model="queryParams" label-width="80px">
        <!-- 查询年份 -->
        <el-form-item label="选择年份">
          <el-date-picker
            v-model="queryParams.year"
            type="year"
            value-format="yyyy"
            placeholder="选择年份"
          >
          </el-date-picker>
        </el-form-item>
        <!-- 操作 -->
          <el-button type="primary" size="small" @click="getBoardData"
            >查询</el-button
          >
          <el-button type="primary" plain size="small" @click="handleResetQuery"
            >重置</el-button
          >
      </el-form>
    </div>
    <!-- 看板内容 -->
    <div class="board-container">
      <div class="container-row1">
        <!-- 售前车故障增减趋势 -->
        <div class="bar-box" style="border-right: 5px solid var(--content-bgColor);">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">售前车故障增减趋势</div>
            </div>
            <div>
              <el-select
                filterable
                v-model="queryParams.carModel"
                placeholder="全部车型"
                clearable
                size="mini"
                @change="
                  getTrendStatis('preCarTrend', {
                    carType: 0,
                    carModel: queryParams.carModel
                  })
                "
              >
                <el-option
                  v-for="item in carTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div>
            <chart
              ref="preCarTrend"
              :height="400"
              :option="trendOption('preCarTrend')"
            />
          </div>
        </div>
        <!-- 售后车故障增减趋势 -->
        <div class="bar-box" style="border-left: 5px solid var(--content-bgColor);">
          <div class="container-title-box">
            <div class="title-box">
              <div class="line"></div>
              <div class="title">售后车故障增减趋势</div>
            </div>
            <div>
              <el-select
                filterable
                v-model="queryParams.carModel2"
                placeholder="全部车型"
                clearable
                size="mini"
                @change="
                  getTrendStatis('afterCarTrend', {
                    carType: 1,
                    carModel: queryParams.carModel2
                  })
                "
              >
                <el-option
                  v-for="item in carTypeList"
                  :key="item.code"
                  :label="item.value"
                  :value="item.code"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div>
            <chart
              ref="afterCarTrend"
              :height="400"
              :option="trendOption('afterCarTrend')"
            />
          </div>
        </div>
      </div>
      <!-- 不同国家不同车型问题增减趋势 -->
      <div class="container-row2">
        <div class="container-title-box">
          <div class="title-box">
            <div class="line"></div>
            <div class="title">不同国家不同车型问题增减趋势</div>
          </div>
          <div class="search-box">
            <el-select
              filterable
              v-model="queryParams.countryId"
              clearable
              size="mini"
              placeholder="全部国家"
              style="margin-right:20px"
              @change="
                getTrendStatis('countryCarModelTrend', {
                  countryId: queryParams.countryId,
                  carModel: queryParams.carModel3
                })
              "
            >
              <el-option
                v-for="item in nationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              filterable
              v-model="queryParams.carModel3"
              placeholder="全部车型"
              clearable
              size="mini"
              @change="
                getTrendStatis('countryCarModelTrend', {
                  countryId: queryParams.countryId,
                  carModel: queryParams.carModel3
                })
              "
            >
              <el-option
                v-for="item in carTypeList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <chart
            ref="countryCarModelTrend"
            :height="400"
            :option="trendOption('countryCarModelTrend')"
          />
        </div>
      </div>
      <!-- 不同国家不同故障类型问题增减趋势 -->
      <div class="container-row3">
        <div class="container-title-box">
          <div class="title-box">
            <div class="line"></div>
            <div class="title">不同国家不同故障类型问题增减趋势</div>
          </div>
          <div class="search-box">
            <el-select
              filterable
              v-model="queryParams.countryId2"
              clearable
              size="mini"
              placeholder="全部国家"
              style="margin-right:20px"
              @change="
                getTrendStatis('countryFaultTypeTrend', {
                  countryId: queryParams.countryId2,
                  faultType: queryParams.faultType
                })
              "
            >
              <el-option
                v-for="item in nationList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              filterable
              v-model="queryParams.faultType"
              placeholder="全部故障类型"
              clearable
              size="mini"
              @change="
                getTrendStatis('countryFaultTypeTrend', {
                  countryId: queryParams.countryId2,
                  faultType: queryParams.faultType
                })
              "
            >
              <el-option
                v-for="item in faultTypeList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <chart
            ref="countryFaultTypeTrend"
            :height="400"
            :option="trendOption('countryFaultTypeTrend')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chart from "@/components/chart";
import { getTrendStatisApi } from "@/api/feedback";
import { getDictItem } from "@/util/dict";
import { getSession } from "@/util/localStor";

// （柱状 | 折现）图
function getBarChartOption(config = {}) {
  return {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow"
      }
    },
    legend: {
      show: config.legend,
      data: config.legend
    },
    grid: config.grid,
    xAxis: {
      type: config.xAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.xAxis
    },
    yAxis: {
      type: config.yAxisType,
      axisLabel: {
        formatter: config.formatter
      },
      data: config.yAxis
    },
    series: config.series
  };
}

export default {
  components: { chart },
  data() {
    return {
      carTypeList: [], // 车型
      faultTypeList: [], // 故障类别
      nationList: Object.values(getSession("nationList")).slice(1), // 国家
      // 查询参数
      queryParams: {
        year: ""
      },
      trendStatis: {
        preCarTrend: {},
        afterCarTrend: {},
        countryCarModelTrend: {},
        countryFaultTypeTrend: {}
      }
    };
  },
  created() {
    this.getCarTypeList(); // 获取车型列表
    this.getFaultTypeList(); // 获取故障类别列表
    this.getBoardData(); // 获取看板数据
  },
  methods: {
    // 获取车型列表
    async getCarTypeList() {
      this.carTypeList = await getDictItem("carType");
    },
    // 获取故障类别列表
    async getFaultTypeList() {
      this.faultTypeList = await getDictItem("badTypeList0");
      this.faultTypeList = this.faultTypeList.concat(
        await getDictItem("badTypeList1")
      );
      // 过滤重复项
      this.faultTypeList = this.faultTypeList.filter((obj, index, self) => {
        return index === self.findIndex(o => o.code === obj.code);
      });
    },
    // 获取本年问题增减趋势
    async getTrendStatis(type, query) {
      this.$refs[type]?.myChart.showLoading();
      try {
        const queryParams = {
          ...query,
          year: this.queryParams.year
        };
        const res = await getTrendStatisApi({ data: queryParams });
        let xAxis = [];
        let dataList = [];
        let dataList2 = [];
        for (let i = 1; i <= 12; i++) {
          const monthData = res.data?.find(item => {
            return item.month === i;
          });
          xAxis[i - 1] = i + "月";
          dataList[i - 1] = monthData ? monthData.total : 0;
          dataList2[i - 1] = monthData ? monthData.closeTotal : 0;
        }
        this.trendStatis[type] = { xAxis, dataList, dataList2 };
      } catch (error) {}
      this.$refs[type]?.myChart.hideLoading();
    },
    // 统计图:本年问题增减趋势
    trendOption(type) {
      const config = {
        legend: ["反馈问题", "已关闭问题"],
        xAxisType: "category",
        yAxisType: "value",
        xAxis: this.trendStatis[type].xAxis,
        series: [
          {
            name: "反馈问题",
            type: "line",
            color: "#5087EC",
            data: this.trendStatis[type].dataList
          },
          {
            name: "已关闭问题",
            type: "line",
            color: "#0EC98E",
            data: this.trendStatis[type].dataList2
          }
        ]
      };
      return getBarChartOption(config);
    },
    // 获取看板数据
    getBoardData() {
      this.getTrendStatis("preCarTrend", { carType: 0 }); // 售前车故障增减趋势
      this.getTrendStatis("afterCarTrend", { carType: 1 }); // 售后车故障增减趋势
      this.getTrendStatis("countryCarModelTrend"); // 不同国家不同车型问题增减趋势
      this.getTrendStatis("countryFaultTypeTrend"); // 不同国家不同故障类型问题增减趋势
    },
    // 重置
    handleResetQuery() {
      this.queryParams = Object.assign({}, this.$options.data()?.queryParams);
      this.getBoardData();
    }
  }
};
</script>
<style src="@/assets/css/qualityStyle.css"></style>
<style lang="scss" scoped>
.container-title-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  .title-box {
    display: flex;
  }
  .line {
    width: 4px;
    height: 20px;
    background-color: var(--theme-color);
    margin-right: 10px;
  }
  .title {
    line-height: 20px;
    color: #101010;
    font-size: 16px;
  }
  .search-box {
    display: flex;
    align-items: center;
  }
}
.board-container {
  .container-row1 {
    display: flex;
    background-color: var(--dash-color);
    margin-bottom: 10px;
    // 
    .bar-box {
      padding: 15px;
      position: relative;
      flex: 1;
    }
  }
  .container-row2,
  .container-row3 {
    background-color: var(--dash-color);
    margin-bottom: 10px;
    padding: 15px;
  }
}
</style>
